module.exports = __webpack_public_path__ + "fonts/PingFangSC-Regular-simple.84e2e3a5.woff2";